import { render, staticRenderFns } from "./JoaDocSendingList.vue?vue&type=template&id=215cb753&scoped=true&"
import script from "./JoaDocSendingList.vue?vue&type=script&lang=js&"
export * from "./JoaDocSendingList.vue?vue&type=script&lang=js&"
import style0 from "./JoaDocSendingList.vue?vue&type=style&index=0&id=215cb753&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cb753",
  null
  
)

export default component.exports